<template>
  <div
    class="group"
    :class="{
      'group--open': open,
    }"
  >
    <div class="group-header" style="width: 100%">
      <div class="group-header__wrapper">
        <button type="button" class="group__toggler" @click="toggle">
          <svg-icon :size="22" name="chevron-top-circled" color="primary"></svg-icon>
        </button>
        <div class="group__name">{{ group.name }}</div>
        <div class="group__count">{{ count }}</div>
      </div>
    </div>
    <transition name="slide">
      <div v-if="open" class="group__list">
        <workers-list ref="list" :days="days" :can-edit="canEdit" :show-all="showAll" :frame="frame"></workers-list>
      </div>
    </transition>
  </div>
</template>

<script>
import WorkersList from "../workers-list";
import SvgIcon from "@/components/svg-icon";

export default {
  name: "worker-group",
  components: {
    WorkersList,
    SvgIcon,
  },
  props: ["group", "groupBy", "days", "canEdit", "searchParams", "showAll", "frame"],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    groupSearchParams() {
      return {
        ...this.searchParams,
        [this.groupBy]: this.group.id,
      };
    },
    count() {
      return this.searchParams.periodStart ? this.group.number_with_vacation : this.group.number;
    },
  },
  watch: {
    searchParams() {
      this.update();
    },
  },
  methods: {
    toggle() {
      if (this.open) {
        this.open = false;
      } else {
        this.open = true;
        this.$nextTick(() => {
          this.$refs.list.update(this.groupSearchParams);
        });
      }
    },
    update() {
      if (!this.open) return;
      this.$refs.list.update(this.groupSearchParams);
    },
  },
};
</script>

<style lang="scss" scoped>
.group {
  margin-top: -1px;
  &-header {
    background: #f5f7fa;
    border: 1px solid #dfe4ef;
    font-size: 13px;
    position: relative;
    z-index: 21;
    margin-top: -1px;
    margin-bottom: -1px;

    &__wrapper {
      position: sticky;
      left: 0;
      display: inline-flex;
      padding-left: 12px;
      min-height: 38px;
      align-items: center;
    }
  }
  &__list {
    margin-bottom: -2px;
  }
  &__toggler {
    background: transparent;
    padding: 0;
    border: none;
    outline: none;
    cursor: pointer;
    flex-shrink: 0;
    margin-right: 10px;
    transition: transform 250ms ease-in-out;
  }
  &__name {
    font-weight: 700;
  }
  &__count {
    color: #8e9cbb;
    margin-left: 5px;
  }
  &--open {
    .group__toggler {
      transform: rotate(180deg);
    }
  }
}
</style>
